import React, { useContext, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import config from "../config/config";
import * as QUERIES from "../queries/query-functions";
import * as UTILS from "../utils/utils";

import { NotificationContext, handleError } from "../context/NotificationContext";
import { getBasketData, refetchBasketData } from "../queries/global";

import LoadingIndicator from "../components/loading-indicator";


const memebrship_removal_error_message = config.OPTION_FIELDS.join_and_book_memberships?.membership_removal_error_message;

export default function CheckForMemberDelete({membershipId, setCheckedForPriority, setShowModal}) {
  const { notification, setNotification } = useContext(NotificationContext);
    const { data: basketData, isFetching: basketDataFetching } = getBasketData(); 

  const [searchParams, setSearchParams] = useSearchParams();
  const dialogRef = useRef(null);

  const removeMembership = useMutation({
    mutationFn: (membershipId) => QUERIES.removeMembership(membershipId),
    onError: (error) => {
        handleError(error.message, setNotification);
    },
    onSuccess: async () => {
            // await queryClient.invalidateQueries({ queryKey: ['basket'], exact: true });
      await refetchBasketData();
    },
  });

  const removeTicket = useMutation({
    mutationFn: (ticketsIdArray) => QUERIES.removeTickets(ticketsIdArray),
    onError: (error) => {
      handleError(error.message, setNotification);
    },
    onSuccess: () => {
      refetchBasketData();
    },
  })  

  useEffect(() => {
      // Stop dialog being closed even by esc key
      const dialog = dialogRef.current;
      if (!dialog) return;
  
      const handleClose = (e) => {
        e.preventDefault();
        dialogRef.current.showModal();
      };

      dialogRef.current?.showModal(); 
  
      dialog.addEventListener("cancel", handleClose);
      dialog.addEventListener("close", handleClose);
  
      return () => {
        dialog.removeEventListener("cancel", handleClose);
        dialog.removeEventListener("close", handleClose);
      };
  }, []);

  const backLogin = async () => {
    searchParams.delete('type');
    setSearchParams(searchParams);

    await removeMembership.mutateAsync(membershipId);

    setCheckedForPriority(false);
    setShowModal(false);
  }

  const clearBasket = async () => {
    const tickets = basketData?.tickets || [];
    const ticketsIdArray = UTILS.getTicketsByInstance(tickets).map(t => t.id);
    if (ticketsIdArray.length) {
        await removeTicket.mutateAsync(ticketsIdArray);
    }

    if(membershipId) {
      await removeMembership.mutateAsync(membershipId);
    }

    window.location.href = config.EVENT_LINK;

  }

  return(
    <div className="booking-pathway__member-delete-check">
      <dialog ref={dialogRef} className="member-delete-dialog">
        <div className="dialog-container">
          <div className="dialog-content">
            <div className="member-delete-dialog__header">
              {memebrship_removal_error_message?.title && <h1 className="member-delete-dialog__title">{memebrship_removal_error_message?.title.innerHTML}</h1>}
              {memebrship_removal_error_message?.message && (
                    <div
                      className="member-delete-dialog__introduction"
                      dangerouslySetInnerHTML={{ __html: memebrship_removal_error_message.message.innerHTML }}
                    ></div>
                  )}
            </div>
            <div className="member-delete-dialog__footer">
              <p className="member-delete-dialog__footer-text">
                Already a member? 
                <button className="btn--link" type="button"
                  disabled={removeMembership.isPending}
                  onClick={() => backLogin()}
                  >Go to login {removeMembership.isPending && <LoadingIndicator/> }</button>
              </p>
              <div className="buttons">
                <button
                  type="button"
                  className="btn btn--primary"
                  onClick={() => setShowModal(false)}
                  >
                    Keep pass and resume booking
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={clearBasket}
                  disabled={removeMembership.isPending || removeTicket.isPending}
                  >
                    Remove and return to event page {removeMembership.isPending || removeTicket.isPending && <LoadingIndicator/> }
                </button>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
}